import type { StoreActionApi } from 'react-sweet-state';
import { v4 } from 'uuid';
import type { HelpseekerMessage, Option } from '../../../common/types';

import type { State } from '../types';

const sendHelpseekerMessage =
    (helpseekerMessage: HelpseekerMessage) =>
    async ({ getState, setState }: StoreActionApi<State>) => {
        const { conversationProvider } = getState();

        const response = await conversationProvider.sendMessage(helpseekerMessage);

        for (let i = 0; i < response.length; i++) {
            setTimeout(() => {
                const { messages } = getState();
                setState({
                    isLoading: false,
                    messages: messages.concat(response[i]),
                });
            }, 1000 * i); // 1000ms delay between each message
        }
    };

export const addMessage =
    (message: string) =>
    async ({ getState, setState, dispatch }: StoreActionApi<State>) => {
        const { messages, conversationProvider, conversationId } = getState();

        const helpseekerMessage: HelpseekerMessage = {
            id: `client::${v4()}`,
            timeCreated: new Date().toISOString(),
            conversationChannelId: conversationId || '',
            message: {
                authorType: 'HELPSEEKER',
                content: message,
            },
        };

        // add user message
        setState({
            isLoading: true,
            messages: [...messages, helpseekerMessage],
        });

        // start new conversation if no conversation id
        if (!conversationId) {
            const response = await conversationProvider.startConversation();

            setState({ conversationId: response.id });
            helpseekerMessage.conversationChannelId = response.id;
        }

        await dispatch(sendHelpseekerMessage(helpseekerMessage));
    };

export const selectOption =
    (option: Option) =>
    ({ getState, setState, dispatch }: StoreActionApi<State>) => {
        const { messages, conversationId } = getState();

        const helpseekerMessage: HelpseekerMessage = {
            id: `client::${v4()}`,
            timeCreated: new Date().toISOString(),
            conversationChannelId: conversationId || '',
            message: {
                authorType: 'HELPSEEKER',
                optionId: option.id,
                content: option.label || '',
            },
        };

        // add user message
        setState({
            isLoading: true,
            messages: [...messages, helpseekerMessage],
        });

        dispatch(sendHelpseekerMessage(helpseekerMessage)).catch((error) => {
            // TODO handle error
            throw new Error(error);
        });
    };

export const clearConversation =
    () =>
    ({ setState }: StoreActionApi<State>) => {
        setState({ messages: [], conversationId: undefined, isLoading: false });
    };
